import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { stageLabel } from "../utils/stages";

// Deployment intent from this snapshot, never evidence of a runtime deployment.
export default function DeploymentStageValues({ plans, field, fallback }) {
  const { t } = useTranslation("freigabe");
  const label = value => t(typeof value !== "boolean" ? "deployment.unknown" : value ? "deployment.yes" : "deployment.no");
  return Array.isArray(plans) && plans.length ? <Stack spacing={0.5}>
    {plans.map(plan => <Typography component="span" variant="body2" key={plan.stage}>{stageLabel(plan.stage)}: {label(plan[field])}</Typography>)}
  </Stack> : label(fallback);
}
